export default __webpack_public_path__ + "static/media/Sinergia_Patrocinios_SUME.c439c25c.jpg";